import { useMemo, useState } from 'react';
import { ChatView, ConversationList } from './components';
import { demoConversations } from './demo-data';
import type { Conversation } from './types';

export default function App() {
  const demoEnabled = import.meta.env.DEV || import.meta.env.VITE_DEMO_MODE === 'true';
  const [conversations, setConversations] = useState<Conversation[]>(
    demoEnabled ? demoConversations : [],
  );
  const [activeId, setActiveId] = useState(conversations[0]?.id ?? '');
  const [mobileChat, setMobileChat] = useState(false);
  const active = useMemo(
    () => conversations.find((item) => item.id === activeId),
    [conversations, activeId],
  );
  const select = (id: string) => {
    setActiveId(id);
    setMobileChat(true);
  };
  const send = (text: string) =>
    setConversations((items) =>
      items.map((item) =>
        item.id === activeId
          ? {
              ...item,
              lastMessage: text,
              time: 'teraz',
              messages: [
                ...item.messages,
                {
                  id: crypto.randomUUID(),
                  author: 'me',
                  text,
                  timestamp: new Intl.DateTimeFormat('pl', {
                    hour: '2-digit',
                    minute: '2-digit',
                  }).format(new Date()),
                  status: navigator.onLine ? 'sent' : 'pending',
                },
              ],
            }
          : item,
      ),
    );
  return (
    <main className={`app-shell ${mobileChat ? 'show-chat' : ''}`}>
      <ConversationList conversations={conversations} activeId={activeId} onSelect={select} />
      {active ? (
        <ChatView conversation={active} onBack={() => setMobileChat(false)} onSend={send} />
      ) : (
        <section className="chat empty-chat">
          <div className="empty-illustration">●—●</div>
          <h1>Twoje rozmowy, blisko Ciebie</h1>
          <p>Wybierz rozmowę albo dodaj kontakt przez Link ID.</p>
        </section>
      )}
      <div className="storage-warning">
        Historia rozmów jest przechowywana na tym urządzeniu. Usunięcie danych aplikacji może
        spowodować jej utratę.
      </div>
    </main>
  );
}
